import React from 'react'
import { Link } from 'react-router-dom'

export default function Footer() {
  return (
    <footer className="bg-stone-100 border-t border-zinc-300 text-zinc-800 pt-16 pb-12 rounded-none font-sans">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Top Call to Action Heading (Industrial-16 Style) */}
        <div className="pb-12 border-b border-zinc-300 flex flex-col md:flex-row md:items-end justify-between gap-6">
          <div className="max-w-3xl">
            <div className="flex items-center gap-2 mb-3 text-orange-600 font-display text-xs tracking-widest uppercase font-bold">
              <span className="w-6 h-0.5 bg-orange-500"></span>
              <span>LAD OS DRØFTE DIT PROJEKT</span>
            </div>
            <h2 className="text-3xl sm:text-5xl font-display font-bold text-zinc-900 uppercase tracking-tight leading-none">
              HAR DU ET BYGGEPROJEKT I TANKERNE? <span className="text-orange-600">KONTAKT OS</span>
            </h2>
          </div>
          <div>
            <Link
              to="/kontakt"
              className="inline-flex items-center justify-center px-6 py-3.5 rounded-none bg-orange-500 hover:bg-orange-600 text-zinc-950 font-display font-bold text-xs uppercase tracking-widest transition-all whitespace-nowrap border border-orange-500"
            >
              <i className="fa-solid fa-paper-plane mr-2" aria-hidden="true"></i>
              <span>Få et tilbud</span>
            </Link>
          </div>
        </div>

        {/* Wireframe Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12 py-12 border-b border-zinc-300">
          
          {/* Column 1: Brand & Logo */}
          <div className="space-y-4">
            <Link to="/" className="inline-flex items-center gap-3 group">
              <img
                src="https://assets.auxodev.dk/assets/bac61bd8-01e8-4025-a9be-38664430d08c/ag-logo.png"
                alt="Agstner Byg ApS Logo"
                className="h-20 sm:h-24 w-auto object-contain"
              />
            </Link>
            <p className="text-xs text-zinc-600 leading-relaxed">
              Kvalitetsbevidst håndværkerfirma i Vissenbjerg. Vi udfører professionelt tømrerarbejde, tagarbejde og gennemgribende boligrenovering på hele Fyn.
            </p>
          </div>

          {/* Column 2: Ydelser Shortcuts */}
          <div>
            <h3 className="font-display font-bold text-sm mb-4 tracking-widest uppercase text-orange-600 flex items-center gap-2">
              <span className="w-1.5 h-1.5 bg-orange-500 inline-block"></span>
              Ydelser
            </h3>
            <ul className="space-y-2.5 text-xs font-medium uppercase tracking-wider">
              <li>
                <Link to="/tomrerarbejde" className="hover:text-orange-600 transition-colors inline-flex items-center gap-2 text-zinc-700">
                  <i className="fa-solid fa-chevron-right text-[10px] text-orange-500" aria-hidden="true"></i>
                  <span>Tømrerarbejde</span>
                </Link>
              </li>
              <li>
                <Link to="/tag" className="hover:text-orange-600 transition-colors inline-flex items-center gap-2 text-zinc-700">
                  <i className="fa-solid fa-chevron-right text-[10px] text-orange-500" aria-hidden="true"></i>
                  <span>Tagarbejde & Nyt Tag</span>
                </Link>
              </li>
              <li>
                <Link to="/renovering" className="hover:text-orange-600 transition-colors inline-flex items-center gap-2 text-zinc-700">
                  <i className="fa-solid fa-chevron-right text-[10px] text-orange-500" aria-hidden="true"></i>
                  <span>Renovering & Modernisering</span>
                </Link>
              </li>
              <li>
                <Link to="/projekter" className="hover:text-orange-600 transition-colors inline-flex items-center gap-2 text-zinc-700">
                  <i className="fa-solid fa-chevron-right text-[10px] text-orange-500" aria-hidden="true"></i>
                  <span>Se udvalgte projekter</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Quick Links */}
          <div>
            <h3 className="font-display font-bold text-sm mb-4 tracking-widest uppercase text-orange-600 flex items-center gap-2">
              <span className="w-1.5 h-1.5 bg-orange-500 inline-block"></span>
              Information
            </h3>
            <ul className="space-y-2.5 text-xs font-medium uppercase tracking-wider">
              <li>
                <Link to="/om-agstner-byg" className="hover:text-orange-600 transition-colors inline-flex items-center gap-2 text-zinc-700">
                  <i className="fa-solid fa-chevron-right text-[10px] text-orange-500" aria-hidden="true"></i>
                  <span>Om Agstner Byg</span>
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="hover:text-orange-600 transition-colors inline-flex items-center gap-2 text-zinc-700">
                  <i className="fa-solid fa-chevron-right text-[10px] text-orange-500" aria-hidden="true"></i>
                  <span>Kontakt os</span>
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="hover:text-orange-600 transition-colors inline-flex items-center gap-2 text-zinc-700">
                  <i className="fa-solid fa-chevron-right text-[10px] text-orange-500" aria-hidden="true"></i>
                  <span>Indhent uforpligtende tilbud</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4: Contact & CTA */}
          <div className="space-y-4">
            <h3 className="font-display font-bold text-sm mb-4 tracking-widest uppercase text-orange-600 flex items-center gap-2">
              <span className="w-1.5 h-1.5 bg-orange-500 inline-block"></span>
              Kontakt os
            </h3>
            <div className="space-y-3 text-xs text-zinc-700">
              <div className="flex items-start gap-3">
                <i className="fa-solid fa-location-dot text-orange-500 mt-1" aria-hidden="true"></i>
                <div>
                  <p className="font-bold text-zinc-900 uppercase font-display">Agstner Byg ApS</p>
                  <p className="text-zinc-600">Odensevej 36</p>
                  <p className="text-zinc-600">5492 Vissenbjerg</p>
                </div>
              </div>

              <div className="flex items-center gap-3">
                <i className="fa-solid fa-phone text-orange-500" aria-hidden="true"></i>
                <a
                  href="tel:+4552502543"
                  className="font-bold text-orange-600 hover:text-orange-700 transition-colors whitespace-nowrap"
                >
                  <span className="whitespace-nowrap">Telefon: 52 50 25 43</span>
                </a>
              </div>

              <div className="flex items-center gap-3">
                <i className="fa-solid fa-envelope text-orange-500" aria-hidden="true"></i>
                <a
                  href="mailto:Agstnerbyg@icloud.com"
                  className="text-zinc-700 hover:text-zinc-950 transition-colors whitespace-nowrap"
                >
                  <span className="whitespace-nowrap">Agstnerbyg@icloud.com</span>
                </a>
              </div>

              <div className="flex items-center gap-3">
                <i className="fa-brands fa-facebook text-orange-500 text-sm" aria-hidden="true"></i>
                <a
                  href="https://www.facebook.com/profile.php?id=61590981091175"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-zinc-700 hover:text-orange-600 font-medium transition-colors whitespace-nowrap inline-flex items-center gap-1.5"
                >
                  <span>Følg os på Facebook</span>
                  <i className="fa-solid fa-arrow-up-right-from-square text-[10px] text-zinc-400" aria-hidden="true"></i>
                </a>
              </div>

              <div className="flex items-center gap-3 text-xs text-zinc-600 pt-1">
                <i className="fa-solid fa-id-card text-orange-500" aria-hidden="true"></i>
                <span>CVR: 44000997</span>
              </div>
            </div>

            <div className="pt-2">
              <Link
                to="/kontakt"
                className="inline-flex items-center justify-center w-full py-2.5 px-4 rounded-none bg-white hover:bg-orange-500 hover:text-zinc-950 text-orange-600 font-display font-bold text-xs uppercase tracking-widest border border-zinc-300 hover:border-orange-500 transition-all text-center whitespace-nowrap"
              >
                Få et tilbud
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom copyright line */}
        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between text-xs text-zinc-500 gap-4 uppercase font-mono">
          <p>© {new Date().getFullYear()} Agstner Byg ApS. Alle rettigheder forbeholdes.</p>
          <div className="flex items-center gap-4 flex-wrap">
            <a
              href="https://www.facebook.com/profile.php?id=61590981091175"
              target="_blank"
              rel="noopener noreferrer"
              className="text-zinc-700 hover:text-orange-600 transition-colors inline-flex items-center gap-1 font-semibold normal-case font-sans"
            >
              <i className="fa-brands fa-facebook text-orange-600 text-sm" aria-hidden="true"></i>
              <span>Facebook</span>
            </a>
            <span className="text-zinc-300">·</span>
            <p className="whitespace-nowrap">CVR: 44000997 · Odensevej 36, 5492 Vissenbjerg</p>
          </div>
        </div>
      </div>
    </footer>
  )
}
